import React from "react";

// Simple on/off filter backed by a single URL param (value "true" when on, absent when off), so it
// round-trips in shareable search URLs. Used for the baggage and transfers package filters.
const FilterToggle = ({ label, description, paramKey, events }) => {
    const on = events.getValue(paramKey) === "true";
    const inputId = `filter-toggle-${paramKey}`;

    const toggle = () => {
        if (on) events.clearValue(paramKey);
        else events.setOption(paramKey, "true");
    };

    return (
        <div className="flex gap-3 cursor-pointer">
            <div className="flex h-5 shrink-0 items-center">
                <input
                    id={inputId}
                    type="checkbox"
                    checked={on}
                    onChange={toggle}
                    className="size-4 rounded-sm border border-gray-300 bg-white text-indigo-600 accent-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                />
            </div>
            <label htmlFor={inputId} className="text-sm text-gray-600">
                {label}
                {description ? <span className="block text-xs text-gray-400">{description}</span> : null}
            </label>
        </div>
    );
};

export default FilterToggle;
